import debouncedSaveTemplate from "fantastic/lib/debouncedSaveTemplate";

export default ({ id }) => (dispatch, getState) => {
  const { target } = window;
  if (target.id === id) return;
  dispatch({ type: "SECTIONS/MOVE", payload: { id, target } });
  debouncedSaveTemplate(dispatch, getState);
};
